export default {"src":"/_next/static/media/mail.0a63f111.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};